import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import RegenerateBIForm from "./indexForm";
// import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import { Box } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import { postWebService } from "../../../helpers/server";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { SLUG_TERM_PRODUCT, SLUG_TROP_PRODUCT } from "../../../constants";

function RegenerateBI({ classes: { loaderBox, main } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState({ open: false, snackbar: false });
  const [isLoaded, setIsLoaded] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [result, setResult] = useState(null);

  const [terminateMessage] = useState(
    "Journey has been terminated because the customer does not want to continue with the revised sum assured which has been calculated using customer's annual income."
  );

  useEffect(() => {
    wrapperToken();
  }, []);

  const wrapperToken = async () => {
    try {
      const header = buildWrapperTokenHeader();
      const response = await postWebService("token.php", {}, header);

      setStorageItem("access-token", response.data.access_token);
      getOrder();
    } catch (error) {
      // console.log(error);
    }
  };

  const validateIIBScore = async () => {
    try {
      const response = await postWebService("checkiibstatus.php", {
        oid: Number(getStorageItem("oid")),
      });

      let dataSlice = response.data.data.slice(9);
      dataSlice = dataSlice.slice(0, -8);

      const data = JSON.parse(atob(dataSlice));

      if (data.code == 200) {
        var status = data.data.status ?? null;
        var reason =
          data.data.reason ?? "Journey terminated due IIB vadilation.";
        if (status === false) {
          setIsLoaded(true);
          setStorageItem("journeyCloseReason", reason);
          navigateTo("terminated");
        } else {
          checkProposedSumAssured();
        }
      }
    } catch (error) {
      cbError(error);
    }
  };

  const getOrder = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("orders.php", {
        checksum,
        oid: getStorageItem("oid"),
      });
      const { data } = response;
      const str = data.data.slice(9, -8);
      const result = JSON.parse(atob(str));
      if (result.checksum === checksum) {
        setOrderDetails(result);
        validateIIBScore();
      }
    } catch (error) {
      setIsLoaded(true);
    }
  };

  const checkProposedSumAssured = async () => {
    cbError("");
    setIsFormSubmitted(true);

    const response = await postWebService("checkproposed-sa.php", {
      oid: getStorageItem("oid"),
      checksum: makeid(),
    });
    const { data } = response;
    setIsLoaded(true);
    setIsFormSubmitted(false);
    if (data?.code === 200) {
      successCallback(data?.data);
    } else if (data?.code === 401) {
      terminateClickHandler(data?.message);
    } else {
      cbError(data?.message);
    }
  };

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setErrors(new Array(error));
  };

  // const isDedupeEnabled = () => orderDetails?.productSlug === SLUG_TROP_PRODUCT;

  const isDedupeEnabled = () => {
    return true;
  };

  const getPathName = (pathname = "bankDetails") =>
    isDedupeEnabled() && pathname === "bankDetails" ? "dedupe" : pathname;

  const navigateTo = (url = "bankDetails") => {
    url = getPathName(url);

    history.push({ pathname: getRoute(url) });
  };

  const retryRegenrationClickHandler = () => {
    checkProposedSumAssured();
  };

  const successCallback = (data = null) => {
    syncProposedSumAssured(data);

    if (!data?.regnenerate_bi) {
      navigateTo();
    }
  };

  const syncProposedSumAssured = (data = null) => {
    console.log(data);
    setResult({
      ...data,
      code: data?.code ?? 200,
      regnenerateBI: data?.regnenerate_bi ?? "",
    });
  };

  const terminateClickHandler = (message = "") => {
    setStorageItem("journeyCloseReason", message);
    navigateTo("terminated");
  };

  const handleVerifyProceed = () => {
    navigateTo();
  };

  return isLoaded ? (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1} mb={0}>
          <SectionTitle title={"Re-Generate BI"} />
        </Box>

        <RegenerateBIForm
          errors={errors}
          modal={modal}
          isFormSubmitted={isFormSubmitted}
          orderDetails={orderDetails}
          terminateMessage={terminateMessage}
          terminateClickHandler={terminateClickHandler}
          retryRegenrationClickHandler={retryRegenrationClickHandler}
          result={result}
          handleVerifyProceed={handleVerifyProceed}
        />
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(RegenerateBI);
